import { render, staticRenderFns } from "./logoComponent.vue?vue&type=template&id=41a64eaf"
import script from "./logoComponent.vue?vue&type=script&lang=ts"
export * from "./logoComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports